import React, { useEffect, useRef, useState } from "react";
import styles from "../mobilesignup2style.module.css";
import { Button, CircularProgress, TextField } from "@mui/material";
import { getFetch } from "../../../fetch/fetch";


const GetStudentPhoneNumber: React.FC<any> = (props) => {

    const [disabled, setDisabled] = useState(true);
    const inputRef = useRef<HTMLInputElement>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        //휴대폰 번호가 대시 제외하고 11자리인지 확인
        const digitsOnly = props.studentPhoneNumber ? props.studentPhoneNumber.replace(/\D/g, '') : '';

        if (digitsOnly.length === 11) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }

    }, [props.studentPhoneNumber]);

    const controlChange = (raw: string) => {

        if (!props.setStudentPhoneNumber) {
            return;
        }

        // 1. 숫자만 남기기
        let digits = raw.replace(/\D/g, "");

        // 2. 앞 3자리는 무조건 010 유지
        if (!digits.startsWith("010")) {
            // 지우려고 해서 0, 01 이런 상태가 되면 그냥 010으로 고정
            if (digits.length <= 3) {
                digits = "010";
            } else {
                // 앞자리를 바꾸려 해도 010으로 강제
                digits = "010" + digits.slice(3);
            }
        }

        // 안전장치: 최소 010은 유지
        if (digits.length < 3) {
            digits = "010";
        }

        // 3. 총 숫자 갯수 제한 (010-1234-5678 => 11자리)
        if (digits.length > 11) {
            digits = digits.slice(0, 11);
        }

        // 4. 자리수에 따라 하이픈 붙이기/빼기
        let formatted = "";
        if (digits.length <= 3) {
            // 010
            formatted = digits;
        } else if (digits.length <= 7) {
            // 010-1 ~ 010-1234
            formatted = digits.slice(0, 3) + "-" + digits.slice(3);
        } else {
            // 010-1234-5 ~ 010-1234-5678
            formatted =
                digits.slice(0, 3) + "-" + digits.slice(3, 7) + "-" + digits.slice(7);
        }

        props.setStudentPhoneNumber(formatted);

        if (digits.length === 11) {
            inputRef.current?.blur();
        }
    };


    const submit = async () => {

        try{

            setLoading(true);

            const result = await props.submit();

            setLoading(false);

        }catch(e){
            console.log(e);
        }
        
    }

    //처음에 focus 처리
        useEffect(() => {
            if (inputRef && inputRef.current) {
                inputRef.current.focus();
            }
        }, [inputRef.current]);


    return (
        <div className={styles.mainContainer} style={{
            height: props.bodyHeight ? `${props.bodyHeight}px` : "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: props.pc ? "" : "space-between",
            // paddingBottom: "39px",
            paddingBottom : props.pc ? "" : "max(var(--safe-area-inset-bottom), 39px)",
        }}>
            <div style={{
                width: "100%",
                marginBottom : props.pc ? "30px" : "0px"
            }}>
                <div style={{
                    paddingTop: "28px",
                    color: "#202632",
                    fontFamily: "Apple_B",
                    fontSize: "24px",
                    lineHeight: "32px",
                    letterSpacing: "-2%",
                }}>
                    연결을 원하는 학생의<br />휴대폰 번호를 입력해주세요
                </div>
                <div style={{
                    marginTop: "40px"
                }}>
                    <div>
                        <TextField
                            variant="standard"
                            label="학생 휴대폰 번호"
                            fullWidth
                            type="tel"
                            sx={{
                                "& .MuiInput-underline::before": {
                                    borderBottom: "1px solid #d3d3d3"
                                },
                                "& .MuiInput-underline": {
                                    height: "40px"
                                },
                                "& .MuiInputBase-input::placeholder": {
                                    fontFamily: "Apple_SB",
                                    color: "#d3d3d3"
                                },
                                "& .MuiInputBase-input": {
                                    fontFamily: "Apple_SB",
                                    color: "#202632",
                                    fontSize: "20px"
                                },
                            }}
                            value={props.studentPhoneNumber ? props.studentPhoneNumber : ""}
                            onChange={(e) => controlChange(e.target.value)}
                            inputRef={inputRef}
                        />
                    </div>
                </div>
            </div>
            <div>
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "#3d50b0",
                        height: "52px",
                        borderRadius: "13px",
                        fontWeight: 500,
                        fontFamily: "Apple_R",
                        boxShadow: "none !important",
                        '&.Mui-disabled': {
                            backgroundColor: '#C1d6f3',
                            color: "white"
                        },
                        "&:hover": {
                            backgroundColor: "#3d50b0",
                            boxShadow: "none",
                        },

                        "&:active": {
                            backgroundColor: "#3d50b0",
                        },

                        "&.Mui-focusVisible": {
                            backgroundColor: "#3d50b0",
                        }
                    }}
                    fullWidth
                    disabled={disabled || loading}
                    onClick={() => {
                        submit();
                     }}
                >
                    {
                        !loading ?
                        "제출하기"
                        :
                        <CircularProgress size={24} style={{ color: "white" }} />
                    }
                </Button>
            </div>
        </div>
    )
}

export default GetStudentPhoneNumber;